import CountrySelect from '@/components/Form/Shared/CountrySelect'
import DistrictSelect from '@/components/Form/Shared/DistrictSelect'
import ProvinceSelect from '@/components/Form/Shared/ProvinceSelect'
import WardSelect from '@/components/Form/Shared/WardSelect'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm, Typogaphy } from 'vnetwork-ui'

interface AddressTabProps {
    formControl: UseFormReturn<any>
    onNext?: () => void
    onPrevious?: () => void
}

const AddressTab: React.FC<AddressTabProps> = ({
    formControl,
    onNext,
    onPrevious,
}) => {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            <div className="space-y-4">
                <Typogaphy
                    size="medium"
                    className="text-primary font-medium capitalize"
                >
                    {t('permanent-address')}
                </Typogaphy>
                <GridHookForm
                    formControl={formControl}
                    actions={[]}
                    subForm={true}
                    className="grid grid-cols-1 md:grid-cols-2 gap-4"
                    data={[
                        {
                            renderEditComponent: (control) => (
                                <CountrySelect
                                    control={control}
                                    name="employee_country"
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_city',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_district',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                        },
                        {
                            renderEditComponent: (control) => (
                                <ProvinceSelect
                                    control={control}
                                    disabled={
                                        !formControl?.watch('employee_country')
                                    }
                                    name="employee_city"
                                    country={formControl?.watch(
                                        'employee_country'
                                    )}
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_district',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                        },
                        {
                            renderEditComponent: (control) => (
                                <DistrictSelect
                                    control={control}
                                    name="employee_district"
                                    disabled={
                                        !formControl?.watch('employee_city')
                                    }
                                    state={formControl.watch('employee_city')}
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                        },
                        {
                            renderEditComponent: (control) => (
                                <WardSelect
                                    control={control}
                                    name="employee_ward"
                                    disabled={
                                        !formControl?.watch('employee_district')
                                    }
                                    state={formControl?.watch('employee_city')}
                                    district={formControl.watch(
                                        'employee_district'
                                    )}
                                />
                            ),
                        },
                        {
                            formItemProps: {
                                name: 'employee_street',
                                type: 'textfield',
                                label: t('street'),
                                placeholder: t('street'),
                            },
                        },
                    ]}
                />
            </div>
            <div className="space-y-4">
                <Typogaphy
                    size="medium"
                    className="text-primary font-medium capitalize"
                >
                    {t('employees.temporary_address')}
                </Typogaphy>
                <GridHookForm
                    formControl={formControl}
                    actions={[
                        {
                            title: t('employees.previous_step'),
                            type: 'button',
                            variant: 'outlined',
                            handler: () => {
                                formControl?.handleSubmit(onPrevious as any)()
                            },
                        },
                        {
                            title: t('employees.next_step'),
                            type: 'button',
                            variant: 'contained',
                            handler: () => {
                                formControl?.handleSubmit(onNext as any)()
                            },
                        },
                    ]}
                    subForm={true}
                    className="grid grid-cols-1 md:grid-cols-2 gap-4"
                    data={[
                        {
                            formItemProps: {
                                name: 'temporary_same_as_permanent',
                                type: 'checkbox',
                                placeholder: t(
                                    'employees.temporary_same_as_permanent'
                                ),
                                onChangeAfterHookForm: () => {
                                    if (
                                        formControl.watch(
                                            'temporary_same_as_permanent'
                                        )
                                    ) {
                                        formControl.setValue(
                                            'employee_temporary_city',
                                            formControl.watch('employee_city')
                                        )
                                        formControl.setValue(
                                            'employee_temporary_district',
                                            formControl.watch(
                                                'employee_district'
                                            )
                                        )
                                        formControl.setValue(
                                            'employee_temporary_ward',
                                            formControl.watch('employee_ward')
                                        )
                                        formControl.setValue(
                                            'employee_temporary_street',
                                            formControl.watch('employee_street')
                                        )
                                    }
                                },
                            },
                            className: 'md:col-span-2',
                        },
                        {
                            renderEditComponent: (control) => (
                                <CountrySelect
                                    control={control}
                                    name="employee_country"
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_temporary_city',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_temporary_district',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_temporary_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                            className: formControl.watch(
                                'temporary_same_as_permanent'
                            )
                                ? 'hidden'
                                : '',
                        },
                        {
                            renderEditComponent: (control) => (
                                <ProvinceSelect
                                    control={control}
                                    disabled={
                                        !formControl?.watch('employee_country')
                                    }
                                    name="employee_temporary_city"
                                    country={formControl.watch(
                                        'employee_country'
                                    )}
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_temporary_district',
                                            ''
                                        )
                                        formControl.setValue(
                                            'employee_temporary_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                            className: formControl.watch(
                                'temporary_same_as_permanent'
                            )
                                ? 'hidden'
                                : '',
                        },
                        {
                            renderEditComponent: (control) => (
                                <DistrictSelect
                                    control={control}
                                    name="employee_temporary_district"
                                    disabled={
                                        !formControl?.watch(
                                            'employee_temporary_city'
                                        )
                                    }
                                    state={formControl.watch(
                                        'employee_temporary_city'
                                    )}
                                    onChangeAfterHookForm={() => {
                                        formControl.setValue(
                                            'employee_temporary_ward',
                                            ''
                                        )
                                    }}
                                />
                            ),
                            className: formControl.watch(
                                'temporary_same_as_permanent'
                            )
                                ? 'hidden'
                                : '',
                        },
                        {
                            renderEditComponent: (control) => (
                                <WardSelect
                                    control={control}
                                    name="employee_ward"
                                    disabled={
                                        !formControl?.watch('employee_district')
                                    }
                                    state={formControl?.watch(
                                        'employee_temporary_city'
                                    )}
                                    district={formControl.watch(
                                        'employee_temporary_district'
                                    )}
                                />
                            ),
                            className: formControl.watch(
                                'temporary_same_as_permanent'
                            )
                                ? 'hidden'
                                : '',
                        },
                        {
                            formItemProps: {
                                name: 'employee_temporary_street',
                                type: 'textfield',
                                label: t('street'),
                                placeholder: t('street'),
                            },
                            className: formControl.watch(
                                'temporary_same_as_permanent'
                            )
                                ? 'hidden'
                                : 'md:col-span-2',
                        },
                    ]}
                />
            </div>
        </div>
    )
}

export default AddressTab
